import React from 'react'
import "bootstrap/dist/css/bootstrap.css"
import "bootstrap/dist/js/bootstrap.bundle"
import '../css/article.css'

export default function YouMayLike() {
  return (

    <>
    <div className='header-containerr'>
    <header className='header-name'>
        <h1>YouMayLike</h1>
    </header>
    </div>
<div className="wrapper">
 
  <div className="article-grid">
    <div className="article-item">
      <div className="image-box">
        <a href="#">
        <img src="./images/Graham-wesley.jpg" alt="News Image 1" />
        </a>
      </div>
      <a href="#" className='anchor'>
      <h2 id='dd'>
      Innovating the Future: A Vision from Wesley Tech Co.
      </h2>
      <p>
      At Wesley Tech Co., innovation isn’t just a buzzword—it’s the driving force behind everything we do. From the moment I founded this company, my vision was clear...


      </p>
      </a>
      <p className="text-muted">By Graham Wesley | Founder & CEO, Wesley Tech Co.</p>
      <a href="#">Read More »</a>
    </div>
    <div className="article-item">
      <div className="image-box">
        <a href="#">
        <img src="./images/Susan-brown.jpg" alt="News Image 2" />
        </a>
      </div>
      <a href="#" className='anchor'>
      <h2>Balancing the Numbers, Nourishing the Future
      </h2>
      <p>
      When I stepped into the role of Chief Financial Officer at Zing Foods and Produce, I knew I was embarking on a journey that combined two of my greatest passions: finance and sustainable food systems...
      </p>
      </a>
      <p className="text-muted">By  Susan Brown
  | CFO, Zing Foods and Produce</p>
      <a href="#">Read More »</a>
    </div>
    <div className="article-item">
      <div className="image-box">
        <a href="#">
        <img src="./images/Fernando-perez.jpg" alt="News Image 3" />
        </a>
      </div>
      <a href="#" className='anchor'>
      <h2>Building Communities, Brick By Brick
      </h2>
      <p>When I founded Pérez & Sons Construction, I wasn’t just starting a business—I was building on a legacy of hard work, integrity, and community values. Our family-run company began with a single pickup truck, a small team of skilled hands...</p>
      </a>
      <p className="text-muted">By Fernando Pérez

  | Founder, Pérez & Sons Construction</p>
      <a href="#">Read More »</a>
    </div>
  </div>
</div>
</>
  )
}
